import React, { useEffect, useState } from "react";
import { useAPIContext } from "../../../context/APIContext";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import Loader from "../../../Layouts/Loader/Loader";
import WebhookApiEditorLatest from "./WebhookApiEditorLatest";
import ErrorMessage from "../../../components/FormComponents/ErrorMessage";

const WebhookApiSectionLatest = (props) => {
  const { selectedApiData, setSelectedApiData } = useAPIContext();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const { file } = props;

  useEffect(() => {
    const fetchWebhook = async (id, endPoint) => {
      try {
        setIsLoading(true);
        const { data } = await axiosInstance.get(`/${endPoint}/${id}`);
        setSelectedApiData(data);
        setIsLoading(false);
      } catch (error) {
        handleApiError(error);
        setIsLoading(false);
        setError(error);
      }
    };
    if (file.id) {
      fetchWebhook(file.id, "webhook-config");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file.id]);

  if (isLoading) {
    return <Loader />;
  }
  if (error) {
    return (
      <div className="d_flex justify_center align_center h_100">
        <ErrorMessage>{error}</ErrorMessage>
      </div>
    );
  }

  if (!selectedApiData) return null;

  return (
    <WebhookApiEditorLatest file={file} selectedApiData={selectedApiData} setSelectedApiData={setSelectedApiData} />
  );
};

export default WebhookApiSectionLatest;
